<header class="subHeader">
    <h2>{{ 'users.label' | translate }}</h2>
    @let mainButtonLabelValue = mainButtonLabel();
    @if (mainButtonLabelValue) {
        <button class="button primary hasIcon" type="button" (click)="pageMainButtonAction()" *appPermission="mainButtonLabelValue">
            <i class="iconSmall fat fa-plus"></i>
            <span>{{ mainButtonLabelValue | translate }}</span>
        </button>
    }
</header>
<app-tab-header>
    <a class="tab" routerLink="../users" routerLinkActive="active" *appPermission="'users.tabs.users'">
        {{ 'users.label' | translate }}
    </a>
    <a class="tab" routerLink="../invitedUsers" routerLinkActive="active" *appPermission="'users.tabs.invitedUsers'">
        {{ 'users.invitedUsers.label' | translate }}
    </a>
    <a class="tab" routerLink="../userGroups" routerLinkActive="active" *appPermission="'users.tabs.userGroups'">
        {{ 'users.userGroups.label' | translate }}
    </a>
    <a class="tab" routerLink="../accessGroups" routerLinkActive="active" *appPermission="'users.tabs.accessGroups'">
        {{ 'users.accessGroups.label' | translate }}
    </a>
    <a class="tab" routerLink="../shijiUsers" routerLinkActive="active" *appPermission="'users.tabs.shijiUsers'">
        {{ 'users.shijiUsers.label' | translate }}
    </a>
</app-tab-header>
<ng-container #usersMainView />
